import { identityNo, password } from './rules';

const { NODE_ENV } = process.env;
const isDevMode = NODE_ENV === 'development';

export const model = isDevMode 
  ? {
      identityNo: 'U269876722',
      password: '123123123',
      shouldRemember: false
    } 
  : {
      identityNo: '',
      password: '',
      shouldRemember: false
    };

export const rules = { identityNo, password };